div<template>
  <div class="bloco-divisao">
    <div class="bloco-divisao-grupo">
      <div class="modal-produto-item">
        <h3>NCM <span>*</span></h3>
        <CenarioInput
          tipo="change"
          :minLengthDropdown="2"
          :maxLengthDropdown="10"
          :loadChange="carregandoNcm"
          mask="####.##.##"
          placeholder="NCM"
          nome="ncm"
          noOptions="Sem opções de NCM"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="ncm"
          :options="ncmOptions"
          @update:model="update => (ncm = update)"
          @selected="update => this.calculaProdutosForm(update, 'ncm')"
        />
      </div>
      <div class="modal-produto-item">
        <h3>EX (TIPI)</h3>
        <CenarioInput
          :loadingLayer="carregandoEx"
          noFilter
          :disabled="desativaEx"
          placeholder="EX"
          :model="ex"
          :options="exOptions"
          @update:model="update => (ex = update)"
          @selected="update => this.calculaProdutosForm(update, 'ex')"
        />
      </div>
      <div class="modal-produto-item">
        <h3>CEST</h3>
        <CenarioInput
          :loadingLayer="carregandoCest"
          :disabled="desativaCest"
          placeholder="CEST"
          :model="cest"
          :options="cestOptions"
          @update:model="update => (cest = update)"
          @selected="update => this.calculaProdutosForm(update, 'cest')"
        />
      </div>
    </div>
    <div class="modal-produto-item">
      <h3>CÓDIGO DO PRODUTO</h3>
      <CenarioInput
        tipo="texto"
        placeholder="Insira o Código do Produto"
        :model="codigo"
        @update:model="update => this.calculaProdutosForm(update, 'codigo_produto')"
      />
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";

import Api from "@/services/api.js";
import { mapActions } from "vuex";

export default {
  name: "ModalProdutoDescricao",
  components: { CenarioInput },
  props: {
    exibeValidacao: Boolean,
    validaCampos: Object,
    produtosForm: Object
  },
  inject: ["calculaProdutosForm", "calculaProdutos"],
  data() {
    return {
      carregandoEx: false,
      carregandoCest: false,
      ncmOptions: [],
      exOptions: [],
      cestOptions: [],
      carregandoNcm: false,
      codigo: "",
      ncm: "",
      ex: "",
      exSelecionado: "",
      cest: "",
      cestSelecionado: "",
      desativaEx: true,
      desativaCest: true
    };
  },
  created() {
    this.$nextTick(() => {
      this.updateDados(true);
    });
  },
  watch: {
    produtosForm: {
      deep: true,
      handler() {
        this.updateDados();
        // if (this.produtosForm.ncm == "") {
        //   this.exOptions = [];
        //   this.desativaEx = true;
        //   this.cestOptions = [];
        //   this.desativaCest = true;
        // }
      }
    },
    ncm() {
      if (this.ncm == "") {
        this.exOptions = [];
        this.desativaEx = true;
        this.cestOptions = [];
        this.desativaCest = true;
        this.cest = "-";
        this.ex = "-";
        this.carregandoEx = false;
        this.carregandoCest = false;
        // this.calculaProdutosForm("-", "cest");
        this.$set(this.produtosForm, "cest", "-");
        this.$set(this.produtosForm, "ex", "-");
      }

      if (this.ncm.length >= 2) {
        this.$nextTick(() => {
          this.buscaDadosNcm();
        });
      }
    }
  },
  methods: {
    ...mapActions("pesquisaNcm", ["fetchPesquisaMtrz"]),
    async buscaDadosNcm() {
      this.carregandoNcm = true;
      if (this.ncm.length == 10) {
        this.carregandoEx = true;
        this.carregandoCest = true;
      }
      let termo = this.ncm;
      const response = await this.fetchPesquisaMtrz({
        valorPesquisa: termo,
        referencia: "NCM",
        autoComplete: "S",
        limite: 10,
        page: 1,
        ordenacao: "ASC"
      });
      if (this.ncm.length == 10 && !!response.data.length) {
        this.exOptions = response
          ? ["-", ...response.data[0].exTipi.map(p => p.ex).filter(f => f != 0)]
          : "-";
        this.desativaEx = this.exOptions.length > 1 ? false : true;
        this.carregandoEx = false;
        const responseCest = await new Api().post("Ncm/obterCestRelacionados", { ncm: termo });
        this.cestOptions = ["-", ...responseCest.dados];
        this.carregandoCest = false;
        this.desativaCest = this.cestOptions.length > 1 ? false : true;
        if (!this.cestOptions.includes(this.produtosForm.cest)) {
          this.$set(this.produtosForm, "cest", "-");
          this.cest = "-";
        }
      }
      // else {
      // this.exOptions = [];
      // this.desativaEx = true;
      // this.cestOptions = [];
      // this.desativaCest = true;
      // }
      // this.calculaProdutos("-", "ex");
      // this.calculaProdutos("-", "cest");
      if (termo == this.ncm) {
        this.$nextTick(() => {
          this.ncmOptions = response.data.map(p => p.ncm);
          this.carregandoNcm = false;
        });
      }
    },
    updateDados(created = false) {
      this.codigo = this.produtosForm.codigo_produto;
      this.ncm = !created && this.ncm == "" ? "" : this.produtosForm.ncm;
      this.ex = this.produtosForm.ex == "0" ? "-" : this.produtosForm.ex;
      this.cest = this.produtosForm.cest == "0" ? "-" : this.produtosForm.cest;
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.bloco-divisao {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px 10px;
}
.bloco-divisao-grupo {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  gap: 10px 10px;
}
.modal-produto-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
